import { useTranslatedOptionEnum } from '@if/mui'
import { EOperationStatus } from '@src/types/constants'
import { CustomerPaymentOperation } from '@src/types/loan/loan-operation'
import { CalendarSimulation } from '@src/types/loan/loan-simulation'

export const getAvailablePaymentStatuses = (currentStatus: EOperationStatus): EOperationStatus[] => {
  const statuses: EOperationStatus[] = []
  switch (currentStatus) {
    case EOperationStatus.Planned:
      statuses.push(EOperationStatus.Complete)
      break
    case EOperationStatus.Complete:
      statuses.push(EOperationStatus.Failed, EOperationStatus.Planned)
      break
    case EOperationStatus.Failed:
      statuses.push(EOperationStatus.Complete)
      break
  }
  return statuses
}

export const useAvailablePaymentStatuses = (currentStatus: EOperationStatus) => {
  return useTranslatedOptionEnum('loan.payment.pmtStatus', getAvailablePaymentStatuses(currentStatus))
}

export const canChangePaymentStatus = (paymentIds: Set<string>, simulation: CalendarSimulation): boolean => {
  if (paymentIds.size === 0) return false

  const selectedPayments = simulation.operationInformations.filter(
    (oi) => paymentIds.has(oi.simulatedOperationId) && oi.isCustomerPaymentOperation(),
  )

  // Some payments are not found or are wrong type
  if (selectedPayments.length !== paymentIds.size) {
    return false
  }

  const currentStatus = selectedPayments[0].operation.operationStatusId

  if (currentStatus === EOperationStatus.Cancelled) return false

  for (const paymentInformation of selectedPayments) {
    const pmt = paymentInformation.operation as CustomerPaymentOperation

    if (pmt.operationStatusId !== currentStatus || pmt.bankJobId !== null) {
      return false
    }
  }

  return true
}
